import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import GuiContext from "config/context/guiContext";
import { useSessionKeepalive } from "features/authentication/hooks/useSessionKeepalive";

const PrivateRoute = () => {
  const { userData } = useContext(GuiContext);

  // Stabilna tačka prijavljenog dela: produžava sesiju na aktivnost dokle god
  // je korisnik unutra, i sam se gasi kad ispadne. Hook interno ćuti dok nema
  // prijave, pa je bezopasan i pre redirekta.
  useSessionKeepalive();

  return userData.accounts ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
